import { Component, inject, signal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  templateUrl: './success-dialog.component.html',
  styleUrl: './success-dialog.component.scss',
  imports: [MatButtonModule],
})
export class SuccessDialogComponent {
  public dialog = inject(MatDialogRef<SuccessDialogComponent>);
  private data = inject(MAT_DIALOG_DATA) as { title: string; message: string; button: string };

  readonly title = signal(this.data.title);
  readonly message = signal(this.data.message);
  readonly button = signal(this.data.button);
}
